import "../../styles/footer/Footer.scss";

function Footer() {
  return <div className="footer">Made with ❤️ in Maine by David Parker</div>;
}

export default Footer;
